import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    this.element.innerHTML = this.element.innerHTML.replace(
      /(https?:\/\/[^\s]+)/g,
      "<a target='blank' data-turbo='false' href='$1'>$1</a>"
    );
  }
}
